import React, { useContext } from 'react';
import { DoughnutChart } from 'utils/components/DoughnutChart/DoughnutChart';
import './OpenSubmissionsDoughnutChart.scss';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import AppContext from 'app/AppContext';
import { createDoughnutSeries } from 'widgets/openSubmissions/doughnut/openSubmissionsDoughnutChartSeries';
import OpenSubmissionsHelp from 'widgets/openSubmissions/help/OpenSubmissionsHelp';
import styleConstants from '../variables.module.scss';
import ShowHideToggle from 'utils/components/ShowHideToggle/ShowHideToggle';
import { OpenSubmissionsConfiguration } from '../store/configuration/OpenSubmissionsConfiguration';
import classNames from 'classnames';
import Tooltip from 'utils/components/Tooltip/Tooltip';
import { useDispatchUpdateWidgetConfiguration } from 'widgets/store/configuration/hooks';
import { OpenSubmissionsChartData } from 'widgets/openSubmissions/OpenSubmissionsChartData';

const defaultDoughnutSize = parseInt(styleConstants.doughnutSize);

interface OpenSubmissionsDoughnutChartProps {
    allowHideDoughnut?: boolean;
    selectedPosition: PortfolioPosition;
    chartData: OpenSubmissionsChartData;
    doughnutSize?: number;
    className?: string;
    hideHelp?: boolean;
}

export default function OpenSubmissionsDoughnutChart(
    props: OpenSubmissionsDoughnutChartProps
) {
    const {
        selectedPosition: { side, symbol },
        chartData,
        allowHideDoughnut,
        doughnutSize: propsDoughnutSize,
        className,
        hideHelp,
    } = props;

    const doughnutSize = propsDoughnutSize
        ? propsDoughnutSize
        : defaultDoughnutSize;

    const { numberFormat } = useContext(AppContext);

    const {
        aggregatedOpenSubmissionsData,
        notConditionalLabel,
        conditionalLabel,
    } = chartData;
    const dispatchUpdateConfig =
        useDispatchUpdateWidgetConfiguration<OpenSubmissionsConfiguration>();

    const onClickHide = () => {
        dispatchUpdateConfig({ hideDoughnut: true });
    };

    const cssClasses = classNames(
        'OpenSubmissionsDoughnutChartContainer',
        className
    );

    return (
        <div className={cssClasses}>
            <>
                <DoughnutChart
                    doughnutSize={doughnutSize}
                    data={createDoughnutSeries(
                        side,
                        aggregatedOpenSubmissionsData,
                        numberFormat
                    )}
                    className="OpenSubmissionsDoughnutChart"
                >
                    <div className="symbol">
                        <Tooltip text={symbol} neverHide={true}>
                            {symbol}
                        </Tooltip>
                    </div>
                    <div className="amount">
                        <Tooltip text={notConditionalLabel} neverHide={true}>
                            {notConditionalLabel}
                        </Tooltip>
                    </div>
                    {aggregatedOpenSubmissionsData.conditional > 0 && (
                        <div className="amount">
                            <Tooltip text={conditionalLabel} neverHide={true}>
                                {conditionalLabel}
                            </Tooltip>
                        </div>
                    )}
                </DoughnutChart>
                {!hideHelp && <OpenSubmissionsHelp side={side} />}
            </>
            {allowHideDoughnut && (
                <ShowHideToggle
                    status={'hide'}
                    hideLabel={true}
                    showDirection={'right'}
                    tooltip={'Hide Pie Chart'}
                    onToggle={onClickHide}
                />
            )}
        </div>
    );
}
